import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "../lib/i18n";

const LangCtx = createContext(null);

function detectInitial() {
  const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
  if (stored && translations[stored]) return stored;
  if (typeof navigator !== "undefined") {
    const nav = (navigator.language || "de").toLowerCase();
    if (nav.startsWith("de")) return "de";
    if (nav.startsWith("en")) return "en";
  }
  return "de";
}

export function LangProvider({ children }) {
  const [lang, setLang] = useState(detectInitial);

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let v = translations[lang];
      for (const p of parts) {
        v = v?.[p];
        if (v == null) return path;
      }
      return v;
    },
    [lang]
  );

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
